/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest
 */
export interface FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest
     */
    GameSystemName: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest(value: object): value is FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest {
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestFromJSON(json: any): FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'GameSystemName': json['GameSystemName'],
    };
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSON(json: any): FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest {
    return FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequestToJSONTyped(value?: FxIdWebFeaturesDocumentsGetUnacceptedDocumentsGetUnacceptedDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameSystemName': value['GameSystemName'],
    };
}

